/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useGetAllPendingKycUserGroupsQuery } from "../../../../../../redux/apiSlice";
import { SearchBar } from "../../SearchBar";
import { AsideMenu } from "../AsideMenu";

export const KYCUserGroupMenu = ({ destination = "/pending-kyc", showCounts = true }) => {
    const { isFetching, data: userGroups } = useGetAllPendingKycUserGroupsQuery();

    const [search, setSearch] = useState("");

    const UserGroupList = userGroups?.filter((val) =>
        val.name?.toLowerCase().includes(search?.toLowerCase())
    );

    return (
        <>
            <SearchBar
                placeholder={"Search User Groups"}
                isLoading={isFetching}
                onInput={(e) => setSearch(e.target.value.trim())}
            />

            {
                UserGroupList?.map((userGroup, i) => (
                    <AsideMenu.NavItem
                        to={`${destination}/${userGroup?.groupId}`}
                        key={i}
                    >
                        {`${userGroup?.name}`.substring(0, 20)}
                        {showCounts && (
                            <>
                                <div className="text-muted">
                                    ({userGroup?.pendingCount?.toLocaleString()} pending KYC)
                                </div>
                                {userGroup?.requiredCount !== undefined && (
                                    <div className="text-muted mt-1">
                                        ({userGroup.requiredCount.toLocaleString()} required KYC)
                                    </div>
                                )}
                                {userGroup?.noneCount !== undefined && (
                                    <div className="text-muted mt-1">
                                        ({userGroup.noneCount.toLocaleString()} none KYC)
                                    </div>
                                )}
                            </>
                        )}
                    </AsideMenu.NavItem>
                ))
            }
        </>
    );
}
